import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import FavoriteIconSvg from './FavoriteIcon.com.svg';

import cn from './style.local.less';

export default class FavoriteIcon extends PureComponent {
  static propTypes = {
    isFilled: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    isFilled: false,
  };

  render() {
    const { isFilled, className } = this.props;

    return (
      <FavoriteIconSvg
        className={cns(cn.icon, className, { [cn.filled]: isFilled })}
      />
    );
  }
}
